module.exports = __webpack_public_path__ + "assets/b10.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b10.png
// module id = 570
// module chunks = 0